import { render, staticRenderFns } from "./ConfirmSection.vue?vue&type=template&id=79e5b13a&"
import script from "./ConfirmSection.vue?vue&type=script&lang=ts&"
export * from "./ConfirmSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports